import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './core/components/layout/main.component';
import { MxAuthGuard } from './core/guards/mx.auth.guard';

import { MxPreloadModulesStrategy } from './core/strategies/mx.preload-modules.strategy';

const app_routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/home/home.module').then((m) => m.HomeModule),
      },
      // {
      //   path: 'settings',
      //   loadChildren: () =>
      //     import('./features/settings/settings.module').then(
      //       (m) => m.SettingsModule
      //     ),
      // },

      {
        path: 'users',
        loadChildren: () =>
          import('./features/users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'message-us',
        loadChildren: () =>
          import('./features/message-us/message-us.module').then(
            (m) => m.MessageUsModule
          ),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./features/products/products.module').then(
            (m) => m.ProductsModule
          ),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./features/orders/orders.module').then((m) => m.OrdersModule),
      },
      {
        path: 'posts',
        loadChildren: () =>
          import('./features/posts/posts.module').then((m) => m.PostsModule),
      },
      {
        path: 'documents',
        loadChildren: () =>
          import('./features/documents/documents.module').then(
            (m) => m.DocumentsModule
          ),
      },
      {
        path: 'subscriptions',
        loadChildren: () =>
          import('./features/subscriptions/subscriptions.module').then(
            (m) => m.SubscriptionsModule
          ),
      },
    ],
    canActivate: [MxAuthGuard],
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('./core/components/pages/mx.pages-routing.module').then(
        (m) => m.MxPagesRoutingModule
      ),
  },
  { path: '**', redirectTo: '/pages/not-found' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(app_routes, {
      preloadingStrategy: MxPreloadModulesStrategy,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [MxPreloadModulesStrategy],
})
export class AppRoutingModule {}
